import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAdminToken } from "../../../helper/adminAuthStorage";
import { exchangeSsoCode } from "./ssoExchange";

// Unlike the site's protected routes (which redirect to WordPress), the admin
// console redirects to its own login when there's no admin token. It also
// accepts an SSO handoff: WordPress redirects here with ?code=<64 hex>, which
// we exchange (server-side, via Node) for an admin token, then strip from the
// URL so it can't leak through history or a Referer.
const CODE_RE = /^[a-f0-9]{64}$/i;

const ProtectedAdminRoute = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");
  const hasToken = !!getAdminToken();
  const canExchange = !hasToken && code && CODE_RE.test(code);

  // "authed" once we have a token; "exchanging" while trading the code; else "denied".
  const [status, setStatus] = useState(hasToken ? "authed" : canExchange ? "exchanging" : "denied");

  useEffect(() => {
    if (status !== "exchanging") return;
    let alive = true;
    (async () => {
      const ok = await exchangeSsoCode(code);
      if (!alive) return;
      if (ok) {
        // Drop the code from the address bar (history, bookmarks, Referer).
        try {
          window.history.replaceState({}, "", "/admin");
        } catch (e) {
          /* ignore */
        }
        setStatus("authed");
      } else {
        setStatus("denied");
      }
    })();
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "exchanging") {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#5b6577",
          fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Arial,sans-serif",
        }}
      >
        Signing you in…
      </div>
    );
  }
  if (status === "denied") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default ProtectedAdminRoute;
